import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LanguageSwitcher from '../../Component/LanguageSwitcher';

const PMVaya = () => {
  const { t } = useTranslation('PMVaya');



  document.title = t('documentTitle');
  document.querySelector('meta[name="description"]').setAttribute('content', t('metaDescription'));
  


  return (
    <div>
      <header className="d-flex justify-content-end align-items-center p-3 border-bottom">
        <LanguageSwitcher />
      </header>

      <div className="webview">
        <Container>
          <Row>
            <Col xs={12}>
              <Trans
                i18nKey="intro1"
                ns="PMVaya"
                components={[
                  <strong key="0" />,
                  <a
                    key="1"
                    title="Pradhan Mantri Vaya Vandana Yojana Modified 2020"
                    href="https://www.goodreturns.in/personal-finance/investment/lic-pradhan-mantri-vaya-vandana-yojana-pmvvy-modified-20-1161378.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                ]}
              />
              <br />
              <br />
              <p dangerouslySetInnerHTML={{ __html: t('intro2') }} />

              <h2>{t('eligibilityHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('eligibilityIntro') }} />
              <ul>
                {t('eligibilityList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>
              <p dangerouslySetInnerHTML={{ __html: t('eligibilityCap') }} />
              <p dangerouslySetInnerHTML={{ __html: t('eligibilityCapDetails') }} />
              <p dangerouslySetInnerHTML={{ __html: t('eligibilityPurchase') }} />

              <h2>{t('documentsHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('documentsIntro') }} />
              <ul>
                {t('documentsList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('taxBenefitsHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('taxBenefitsIntro') }} />

              <h2>{t('keyBenefitsHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('keyBenefitsIntro') }} />
              <h4>{t('pensionPaymentHeader')}</h4>
              <p dangerouslySetInnerHTML={{ __html: t('pensionPayment') }} />
              <h4>{t('deathBenefitHeader')}</h4>
              <p dangerouslySetInnerHTML={{ __html: t('deathBenefit') }} />
              <h4>{t('maturityBenefitHeader')}</h4>
              <p dangerouslySetInnerHTML={{ __html: t('maturityBenefit') }} />

              <h2>{t('featuresHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('featuresIntro') }} />
              <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                {t('featuresList', { returnObjects: true }).map((item, index) => (
                  <li key={index} style={{ marginBottom: '10px' }} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('pensionPolicyHeader')}</h2>
              <ul>
                {t('pensionPolicyList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('loansHeader')}</h2>
              <ul>
                {t('loansList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('paymentModeHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('paymentMode') }} />

              <h2>{t('freeLockInHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('freeLockIn') }} />

              <h2>{t('surrenderValueHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('surrenderValue') }} />

              <h2>{t('processHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('processIntro') }} />
              <h4>{t('processOnlineHeader')}</h4>
              <ul>
                {t('processOnlineList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('prematureWithdrawalHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('prematureWithdrawal') }} />

              <h2>{t('considerHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('considerIntro') }} />

              <h2>{t('newRulesHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('newRulesIntro') }} />
              <p dangerouslySetInnerHTML={{ __html: t('newRulesDetails') }} />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PMVaya;